import React from "react";

export default function DistrictSnapshotCard({
  district = "Gadchiroli",
  riskScore = 65,
  metrics = [
    { label: "MMR", value: 68 },
    { label: "NMR", value: 24 },
    { label: "LBW %", value: 13 },
    { label: "ANC 4+ %", value: 61 },
    { label: "Inst. Delivery %", value: 76 },
    { label: "Reporting (7d)", value: 84 },
    { label: "C-section Rate", value: 28 },
    { label: "High-risk Flagged %", value: 12 },
  ],
}) {
  return (
    <div className="bg-white rounded-2xl px-4 py-4 shadow-sm border border-slate-200 w-full">

      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-base font-semibold text-slate-800">
          {district}
        </h3>
        <span className="text-xs bg-slate-100 text-slate-700 px-2 py-1 rounded-lg border">
          Risk score: {riskScore}
        </span>
      </div>

      {/* Metrics - 2 columns */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        {metrics.map((m, i) => (
          <div key={i} className="w-full">
            
            {/* Label + Value */}
            <div className="flex justify-between text-xs mb-1">
              <span className="text-slate-600">{m.label}</span>
              <span className="text-slate-900 font-semibold">{m.value}%</span>
            </div>

            {/* Progress Bar */}
            <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full"
                style={{
                  width: `${m.value}%`,
                  backgroundColor: "#4FA3F9",
                }}
              ></div>
            </div>

          </div>
        ))}
      </div>

    </div>
  );
}
